"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComponentHeader = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Sanitizer = require("../Sanitizer/Sanitizer");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ComponentHeader = exports.ComponentHeader = function ComponentHeader(_ref) {
  var className = _ref.className,
    Component = _ref.Component,
    title = _ref.title,
    styles = _ref.styles,
    subTitle = _ref.subTitle,
    qeId = _ref.qeId;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('component-header', className, styles.componentHeader),
    "data-qe-id": qeId
  }, /*#__PURE__*/_react["default"].createElement(_Sanitizer.Sanitizer, {
    safelySetInnerHTML: title,
    Component: Component
  }), subTitle && /*#__PURE__*/_react["default"].createElement(_Sanitizer.Sanitizer, {
    safelySetInnerHTML: subTitle
  }));
};
ComponentHeader.propTypes = {
  className: _propTypes["default"].string,
  Component: _propTypes["default"].node,
  title: _propTypes["default"].string.isRequired,
  styles: _propTypes["default"].objectOf(_propTypes["default"].string),
  subTitle: _propTypes["default"].string,
  qeId: _propTypes["default"].string
};
ComponentHeader.defaultProps = {
  className: undefined,
  Component: 'span',
  styles: {},
  subTitle: undefined,
  qeId: undefined
};